import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AnalFissurePage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Anal Fissure</h1>
        <section className="mb-8">
          <p>An anal fissure is a small tear in the lining of the anus, often causing pain and bleeding during bowel movements. It can be uncomfortable and persistent, but natural therapies can help soothe symptoms and promote healing without harsh interventions.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Chronic constipation or diarrhea</li>
            <li>Straining during bowel movements</li>
            <li>Childbirth</li>
            <li>Inflammatory bowel disease</li>
            <li>Anal trauma</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Pain during or after bowel movements</li>
            <li>Bright red blood on stool or tissue</li>
            <li>Itching or irritation</li>
            <li>Visible tear or crack</li>
            <li>Spasms in the anal sphincter</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbal applications, dietary guidance, and gentle therapies to reduce pain, promote healing, and prevent recurrence. Our treatments are gentle and support the body's natural recovery process.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces pain and discomfort</li>
            <li>Promotes natural healing</li>
            <li>Minimizes risk of recurrence</li>
            <li>No harsh chemicals</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a fiber-rich diet</li>
            <li>Stay hydrated</li>
            <li>Avoid straining during bowel movements</li>
            <li>Maintain good hygiene</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment heal an anal fissure?</strong>
            <p>A: Yes, our approach can support healing and symptom relief, especially with early intervention.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for sensitive skin?</strong>
            <p>A: Yes, our remedies are gentle and soothing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice relief within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find gentle relief—book your herbal fissure care session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default AnalFissurePage; 